import { render, staticRenderFns } from "./MagicLinks.vue?vue&type=template&id=0bc50459&"
import script from "./MagicLinks.vue?vue&type=script&lang=js&"
export * from "./MagicLinks.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports